export default __webpack_public_path__ + "static/V-ALI1_Kevyt_alivalotus-f58c9ef1c9ba56fb79585a24afc789e1.jpg";